import { render } from "./BoxView.vue?vue&type=template&id=fe0a9322"
import script from "./BoxView.vue?vue&type=script&lang=js"
export * from "./BoxView.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__